import { GlobalController } from 'src/shared/global/GlobalController'
import AuditInvoiceReport from './AuditInvoiceReport.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'audit-report',
    name:
      'AuditInvoiceReport',
    component: AuditInvoiceReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
